export default __webpack_public_path__ + "static/media/STL_Code_of_fair_disclosure_PIT_2.26f9c753.pdf";